module.exports = __webpack_public_path__ + "static/img/dsh5.684dbf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingParty/dsh5.jpg
// module id = 2DjO
// module chunks = 0